import { DateRangePicker, Text, HStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { useReportsActions } from '../../../../../../../store/customerDetail/reports/actions';
import { reportPeriodDatesState } from '../../../../../../../store/customerDetail/reports/atom';

export const DailyPeriod = () => {
  const reportPeriodDates = useRecoilValue(reportPeriodDatesState);
  const { updateReportPeriodDates } = useReportsActions();

  const onSelectDates = (initialDate: Date, finalDate: Date) =>
    updateReportPeriodDates({
      startDate: initialDate,
      endDate: finalDate,
    });

  return (
    <HStack alignItems="center">
      <Text
        variant="regular"
        fontSize={Typography['fontsize.md']}
        color="neutral.medium"
        noOfLines={1}>
        Filtre por data:
      </Text>
      <DateRangePicker
        onClear={() => {}}
        forceMobile
        initialDate={reportPeriodDates.startDate}
        finalDate={reportPeriodDates.endDate}
        placeholder="Data atual"
        onSelectDates={onSelectDates}
        calendarPosition="right"
      />
    </HStack>
  );
};
